import { Box, Modal, Typography } from '@mui/material';
import Input from 'components/Common/Input';
import { useForm } from 'react-hook-form';
import Button from 'components/Common/Button';
import { useNavigate, useParams } from 'react-router-dom';
import { useCreateOrUpdateKnowledgeBase, useGetKnowledgeBase } from 'apis/business/setting/knowledgeBase/hook';
import Spinner from 'components/Common/Spinner';
import { knowledgeBaseSchema } from 'utils/schema/validator/KnowledgeBaseValidation';
import { zodResolver } from '@hookform/resolvers/zod';

export default function KnowledgeBaseForm() {
  const navigate = useNavigate();
  const { knowledgeBaseId } = useParams();

  const { data: knowledgeBase, isLoading } = useGetKnowledgeBase();

  const { handleSubmit, control } = useForm({
    resolver: zodResolver(knowledgeBaseSchema),
    values: { knowledgebase: knowledgeBase }
  });

  const { mutate: handleKnowledgeBase } = useCreateOrUpdateKnowledgeBase();

  const onSubmit = (data: any) => {
    handleKnowledgeBase(data);
  };

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <Modal
      open={true}
      onClose={() => navigate(-1)}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
    >
      <Box sx={style}>
        <Typography variant='h6'>{knowledgeBaseId ? 'Edit' : 'Create'} Knowledge Base</Typography>
        <Box component='form' onSubmit={handleSubmit(onSubmit)} mt={2}>
          <Input name='knowledgebase.name' label='Name' control={control} fullWidth required />
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'end',
              gap: '16px',
              marginTop: '24px'
            }}
          >
            <Button
              color='secondary'
              variant='outlined'
              sx={{ border: '1px solid #F3F3F3' }}
              onClick={() => navigate(-1)}
            >
              Cancel
            </Button>
            <Button type='submit' variant='contained'>
              {knowledgeBaseId ? 'update' : 'Create'}
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: '1px solid #F3F3F3',
  boxShadow: 24,
  p: 4,
  borderRadius: '8px',
  width: {
    xs: '90%',
    sm: 400,
    md: 600,
    lg: 800
  }
};
